export default {
  nav: { title: 'Mon travail', today: 'Aujourd’hui', calendar: 'Calendrier', history: 'Historique', payroll: 'Paie', messages: 'Messages', profile: 'Profil' },
  state: { upcoming: 'À venir', EN_ROUTE: 'En route', ARRIVED: 'Arrivé', IN_PROGRESS: 'En cours', COMPLETED: 'Terminé' },
  common: {
    myPay: 'Montant employé',
    estimated: 'Durée prévue',
    pets: 'Animaux',
    petsOnSite: 'Animaux sur place',
    view: 'Voir',
    directions: 'Itinéraire',
    previousDay: 'Jour précédent',
    nextDay: 'Jour suivant',
    previousWeek: 'Semaine précédente',
    nextWeek: 'Semaine suivante',
    thisWeek: 'Cette semaine',
    priority: 'Priorité {{priority}}',
    jobNumber: 'Ménage n° {{number}}',
  },
  today: {
    hello: 'Bonjour {{name}}',
    count_zero: 'Aucun ménage ce jour-là',
    count_one: '{{count}} ménage aujourd’hui',
    count_other: '{{count}} ménages aujourd’hui',
    countOther_one: '{{count}} ménage',
    countOther_other: '{{count}} ménages',
    dayOff: 'Journée libre',
    dayOffHint: 'Aucun ménage prévu ce jour-là. Profitez-en!',
    seeCalendar: 'Voir mon calendrier',
    route: 'Ordre suggéré',
    routeTotal: '{{km}} km · {{minutes}} min de route au total',
    travel: '{{minutes}} min de route',
    late: 'Risque de retard de {{minutes}} min',
    noCoordinates: 'Adresse non localisée',
  },
  job: {
    title: 'Ménage',
    important: 'Important',
    priority: 'Priorité',
    parking: 'Stationnement',
    instructions: 'Consignes spéciales',
    permanentNotes: 'Notes permanentes',
    forbiddenAreas: 'Zones interdites',
    preferences: 'Préférences du client',
    specialProducts: 'Produits particuliers',
    nothingImportant: 'Aucune consigne particulière.',
    access: 'Accès',
    showAccess: 'Voir les accès',
    hideAccess: 'Masquer les accès',
    accessHint: 'Informations confidentielles : chaque consultation est enregistrée.',
    noAccess: 'Aucune information d’accès enregistrée.',
    property: 'Propriété',
    propertySummary: '{{bedrooms}} ch. · {{bathrooms}} sdb · {{floors}} étage(s)',
    team: 'Équipe',
    checklist: 'Liste de tâches',
    progress: '{{done}} / {{total}} tâches',
    checklistLocked: 'Commencez le ménage pour cocher les tâches.',
    noTasks: 'Aucune tâche pour ce ménage.',
    optionalTask: 'facultatif',
    action: {
      CONFIRMED: 'Confirmer',
      EN_ROUTE: 'Je suis en route',
      ARRIVED: 'Je suis arrivé(e)',
      IN_PROGRESS: 'Commencer le ménage',
      COMPLETED: 'Terminer le ménage',
    },
    statusDone: {
      CONFIRMED: 'Ménage confirmé.',
      EN_ROUTE: 'Bonne route!',
      ARRIVED: 'Arrivée enregistrée.',
      IN_PROGRESS: 'Ménage commencé.',
      COMPLETED: 'Ménage terminé.',
    },
    finishTitle: 'Terminer ce ménage?',
    finishDescription: 'Vérifiez que toutes les tâches sont faites avant de terminer.',
    finishNotes: 'Notes de fin (facultatif)',
    finishNotesPlaceholder: 'Ex. : produit à racheter, objet brisé, remarque pour le bureau…',
    finishConfirm: 'Terminer',
    missingTitle: 'Tâches obligatoires non cochées',
    requiredLeft_one: '{{count}} tâche obligatoire reste à compléter.',
    requiredLeft_other: '{{count}} tâches obligatoires restent à compléter.',
    sectionDone: 'Section terminée',
    missingHint: 'Cochez ces tâches avant de terminer, ou écrivez au bureau en cas de problème.',
    completedTitle: 'Bravo, ménage terminé!',
    completedHint: 'Merci pour votre travail. Le bureau a été avisé.',
    backToday: 'Retour à ma journée',
    reviewRequired: 'Ce ménage sera vérifié par le bureau.',
    cancelled: 'Ce ménage a été annulé.',
    writeOffice: 'Écrire au bureau',
  },
  calendar: {
    title: 'Calendrier',
    week: 'Semaine du {{date}}',
    free: 'Libre',
    empty: 'Aucun ménage cette semaine.',
  },
  history: {
    title: 'Historique',
    subtitle: 'Vos ménages terminés',
    empty: 'Aucun ménage terminé sur cette période.',
    range: {
      '30': '30 derniers jours',
      '90': '3 derniers mois',
      '365': '12 derniers mois',
    },
    rangeLabel: 'Période',
    totals: '{{count}} ménage(s) · {{amount}}',
  },
  payroll: {
    title: 'Paie',
    subtitle: 'Montants calculés à partir de vos ménages terminés.',
    week: 'Cette semaine',
    period: 'Période de paie',
    periodRange: 'Du {{from}} au {{to}}',
    pending: 'En attente',
    pendingHint: 'À approuver par le bureau',
    approved: 'Approuvé',
    approvedHint: 'Sera versé à la prochaine paie',
    entries: 'Détail',
    empty: 'Aucune ligne de paie pour le moment.',
    emptyHint: 'Vos montants apparaîtront ici après chaque ménage terminé.',
    entryMinutes: '{{minutes}}',
  },
  messages: {
    title: 'Messages',
    subtitle: 'Écrivez au bureau pour toute question.',
    new: 'Nouveau message',
    newDescription: 'Votre message sera envoyé au bureau.',
    subject: 'Objet (facultatif)',
    body: 'Message',
    send: 'Envoyer',
    selectHint: 'Choisissez une conversation.',
    back: 'Toutes les conversations',
    sent: 'Message envoyé.',
  },
  profile: {
    title: 'Mon profil',
    contact: 'Coordonnées',
    vehicle: 'Véhicule',
    hasVehicle: 'Oui',
    noVehicle: 'Non',
    skills: 'Compétences',
    sectors: 'Secteurs',
    teams: 'Équipes',
    availability: 'Disponibilités habituelles',
    availabilityHint: 'Pour les modifier, écrivez au bureau.',
    unavailable: 'Non disponible',
    timeOff: 'Absences prévues',
    noTimeOff: 'Aucune absence prévue.',
    declare: 'Déclarer une absence',
    startDate: 'Du',
    endDate: 'Au',
    reason: 'Raison (facultatif)',
    submit: 'Envoyer la demande',
    declared: 'Absence enregistrée. Le bureau en est informé.',
    invalidRange: 'La date de fin doit être après la date de début.',
    language: 'Langue',
    skill: {
      STANDARD: 'Ménage standard',
      DEEP: 'Grand ménage',
      PETS_OK: 'À l’aise avec les animaux',
      MOVE: 'Déménagement',
      COMMERCIAL: 'Commercial',
      WINDOWS: 'Fenêtres',
    },
  },
};
